<script setup lang="ts">
import { computed, inject, onMounted, ref } from 'vue';
import type { Notify } from '@/composables/notifications';
import SectionFederationEmployeeRelationPage from './SectionFederationEmployeeRelationPage.vue';
import { SphSelect } from '@/components/base/select';
import axios from 'axios';

defineOptions({
    compatConfig: { MODE: 3 },
})

const props = defineProps<{
    federationId: number
}>()

const notify = inject<Notify>('notify')!

interface Employee { id: number; name: string }

const employees = ref<Employee[]>([])
const selectedEmployeeId = ref<string | undefined>(undefined)

const employeeOptions = computed(() =>
    employees.value.map(e => ({ value: String(e.id), label: e.name }))
)

const selectedEmployee = computed(() =>
    employees.value.find(e => String(e.id) === selectedEmployeeId.value) ?? null
)

onMounted(() => {
    axios.get(`/federations/${props.federationId}/federation-employees`)
        .then(r => {
            employees.value = r.data.data.map((d: any) => ({
                id: d.id,
                name: `${d.firstName} ${d.lastName}`,
            }))
        })
        .catch(() => notify.error('error.loadingData'))
})
</script>

<template>
    <div>
        <SphSelect
            v-model="selectedEmployeeId"
            :options="employeeOptions"
            class="kgr-row"
        />
        <SectionFederationEmployeeRelationPage
            :federation-id="federationId"
            :federation-employee-id="selectedEmployee?.id || 0"
        />
    </div>
</template>
